/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface NDADialogProps {
  open: boolean;
  setOpen: any;
}

const NDADialog = (props: NDADialogProps) => {
  const descriptionElementRef = useRef(null);

  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      scroll="paper"
      maxWidth="lg"
      PaperProps={{
        sx: {
          borderRadius: 5,
          background: (theme) => theme.palette.modal.main,
        },
      }}
    >
      <DialogTitle>Non-Disclosure Agreement</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText ref={descriptionElementRef} tabIndex={-1}>
          The Collabro Roster Panel is provided at no cost for a 4 week period
          which can be extended on mutual agreement. This will allow the user at
          Jadestone to provide feedback to the Collabro team. Noting the use is
          read only to the live data. The IPR is owned by Collabro and is shared
          confidentially with Jadestone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          sx={{
            borderRadius: 10,
          }}
          variant="contained"
          onClick={handleClose}
        >
          Acknowledge
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NDADialog;
